import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "image-banner-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.75 5C21.75 3.48122 20.5188 2.25 19 2.25L5 2.25C3.48122 2.25 2.25 3.48122 2.25 5L2.25 10C2.25 11.5188 3.48122 12.75 5 12.75L19 12.75C20.5188 12.75 21.75 11.5188 21.75 10V5ZM19 3.75C19.6904 3.75 20.25 4.30964 20.25 5V10C20.25 10.6904 19.6904 11.25 19 11.25L5 11.25C4.30964 11.25 3.75 10.6904 3.75 10L3.75 5C3.75 4.30964 4.30964 3.75 5 3.75L19 3.75ZM5 19.75C4.58579 19.75 4.25 20.0858 4.25 20.5C4.25 20.9142 4.58579 21.25 5 21.25L19 21.25C19.4142 21.25 19.75 20.9142 19.75 20.5C19.75 20.0858 19.4142 19.75 19 19.75L5 19.75ZM4.25 16.0291C4.25 15.6148 4.58579 15.2791 5 15.2791L19 15.2791C19.4142 15.2791 19.75 15.6148 19.75 16.0291C19.75 16.4433 19.4142 16.7791 19 16.7791L5 16.7791C4.58579 16.7791 4.25 16.4433 4.25 16.0291ZM15 8.25C15.4142 8.25 15.75 7.91422 15.75 7.5C15.75 7.08579 15.4142 6.75 15 6.75L9 6.75C8.58579 6.75 8.25 7.08579 8.25 7.5C8.25 7.91421 8.58579 8.25 9 8.25L15 8.25Z"
    }, null, -1)
  ])))
}
export default { render: render }